module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./modules/socketapilegacy/~/isarray/index.js
// module id = 221
// module chunks = 0